import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import CommonCardHeader from '../../../../../Utils/CommonComponents/CommonCardHeader'
import { Dollar, Plan, Purchase, SimplePricingTitle } from '../../../../../Utils/Constants'
import { simplePricingData } from '../../../../../Data/AppsData/EcommerceData/PricingData'
import { Btn, H5, H4, H6 } from '../../../../../AbstractElements'

export default function SimplePricingCard() {
    return (
        <Card>
            <CommonCardHeader headClass='pb-0' title={SimplePricingTitle} />
            <CardBody className="pricing-content">
                <Row className="g-sm-4 g-3">
                    {simplePricingData.map((data) => (
                        <Col lg={3} sm={6} className="box-col-3" key={data.id}>
                            <Card className="text-center pricing-simple">
                                <CardBody>
                                    <H4>{data.title}</H4>
                                    <H5>{Dollar}{data.amount}</H5>
                                    <H6 className="mb-0">{data.title} {Plan}</H6>
                                </CardBody>
                                <Btn size="lg" color="primary" className='btn-block'>
                                    {Purchase}
                                </Btn>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </CardBody>
        </Card>
    )
}
